<template>
  <div class="activity-feed">
    <b-row class="p-4">
      <b-col cols="12" md>
          <h3><strong>Activity feed</strong></h3>
      </b-col>
      <b-col cols="auto">
        <filter-with v-model="filters" />
      </b-col>
    </b-row>
    <div v-if="!loading" class="activity-feed-content">
      <activity-feed-item
        v-for="feed in filteredFeeds"
        :key="feed.id"
        :feed="feed"
        :collapsed="collapsed[feed.type]"
        collapsible
        @type-click="collapsed[$event] = !collapsed[$event]"
      >
        <template #send-message="data">
          <slot name="send-message" v-bind="data" />
        </template>
      </activity-feed-item>
      <div v-if="!filteredFeeds.length" class="activity-feed-empty">
        No activity yet
      </div>
    </div>
    <div v-else class="text-center p-5">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import ActivityFeedItem from './ActivityFeedItem.vue'
import FilterWith from './FilterWith.vue'
import { CATEGORY_TYPE } from '@/helpers/types'

export default {
  name: 'ActivityFeed',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    feeds: {
      type: Array,
      default: () => ([])
    }
  },

  data() {
    return {
      filters: Object.values(CATEGORY_TYPE),
      collapsed: Object.values(CATEGORY_TYPE).reduce((out, val) => { out[val] = false; return out }, {})
    }
  },

  computed: {
    filteredFeeds() {
      let feeds = this.filters.length === Object.values(CATEGORY_TYPE).length
        ? this.feeds
        : this.feeds.filter(feed => this.filters.indexOf(feed.type) !== -1)

      if (this.hasCollapsed) {
        const mostRecent = {}
        feeds = feeds.filter(feed => {
          if (this.collapsed[feed.type]) {
            if (!mostRecent[feed.type]) {
              mostRecent[feed.type] = true
              return true
            }
          } else {
            return true
          }
        })
      }

      return feeds
    },

    hasCollapsed() {
      return Object.values(CATEGORY_TYPE).reduce((out, val) => (out || this.collapsed[val]), false)
    }
  },

  components: {
    ActivityFeedItem,
    FilterWith
  }
}
</script>
